import _ from 'lodash';
import slugger from '../slugger';
import itemDefault from '../images/item-default.png';
import SliderGalleryAttributes from '../config/sliderGalleryAttributes';

export default class SliderGalleryItem {
  constructor({
    title,
    subtitle,
    imagePath,
    linkTo,
  }) {
    this.title = title;
    this.subtitle = subtitle;
    this.imagePath = imagePath;
    this.linkTo = linkTo;
  }

  static ItemFromGenericItemModel(item, category, subcatType, subcatKey) {
    const attr = SliderGalleryAttributes.AttributesFromGenericItemModel(item);

    return new SliderGalleryItem({
      title: attr.title,
      subtitle: attr.subtitle,
      imagePath: _.get(item.getImages(), '[0].thumbnailPath', itemDefault),
      linkTo: `/collections/${category}/${subcatType}/${slugger(subcatKey)}/${item.id}`,
    });
  }

  // Picks out the key from each property in the passed in object,
  // using that as the title for the SliderGalleryItem, and picking
  // the first image it finds as the item image.
  static ItemsFromCategory(categoryItems, category, subcatType) {
    return _.sortBy(
      _.map(
        categoryItems,
        (itemArray, subcatKey) =>
          new SliderGalleryItem({
            title: subcatKey,
            subtitle: `${itemArray.length} item${itemArray.length > 1 ? 's' : ''}`,
            imagePath: _.get(itemArray[0].getImages(), '[0].thumbnailPath', itemDefault),
            linkTo: `/collections/${category}/${subcatType}/${slugger(subcatKey)}`,
          })
      ),
      ['title']
    );
  }

  // Given a category and a subcategory, creates new models for
  // each item in that combination
  static ItemsFromSubcategory(subcategoryItems, category, subcatType, subcatKey) {
    return _.sortBy(
      _.map(subcategoryItems, item =>
        SliderGalleryItem.ItemFromGenericItemModel(item, category, subcatType, subcatKey)),
      ['title']
    );
  }
}



// WEBPACK FOOTER //
// ./src/models/SliderGalleryItem.js